import { useEffect } from "react";
import { i18n } from "./index";

const syncLang = () => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = i18n.resolvedLanguage ?? i18n.language;
};

/**
 * Hook to synchronize the HTML document's lang attribute with the current i18n language.
 */
export const useSyncHtmlLang = () => {
  useEffect(() => {
    syncLang();
    i18n.on("languageChanged", syncLang);
    return () => {
      i18n.off("languageChanged", syncLang);
    };
  }, []);
};
